import PropTypes from 'prop-types';
import React from 'react';
import styles from './Title.css';

class Title extends React.PureComponent {
  render() {
    const { title, titleSize, noBorder } = this.props;
    return (
      <div
        className={`${styles.title} ${!noBorder && styles.border}`}
        style={{ fontSize: titleSize }}
      >
        {title}
      </div>
    );
  }
}

Title.propTypes = {
  title: PropTypes.string,
  noBorder: PropTypes.bool,
  titleSize: PropTypes.number,
};

Title.defaultProps = {
  noBorder: false,
};

Title.defaultProps = {
  titleSize: '24px',
};

export default Title;
